import { useGetProductFullView } from 'hooks';
import { useParams } from 'react-router-dom';
import { useDispatchReloadPage } from 'hooks/useReloadPage';
import SupplierManagerModal from 'pages/company-profile/components/tabs/system/supplier-management/components/SupplierManagerModal';

const QaSpecAssignToSupplierModal = ({ visible, setVisible, isQaSpecPath }) => {
  const { id: productId } = useParams();
  const { productFull } = useGetProductFullView({ productId });

  const isProductDetail = true;

  const reloadPage = useDispatchReloadPage();

  const handleReloadPage = () => {
    reloadPage();
  };

  return (
    <SupplierManagerModal
      isEdit={false}
      visible={visible}
      setVisible={setVisible}
      title={`Initiate QA Specification Workflow`}
      isPIMAction={true}
      productSelected={[{ ...productFull, id: productId }]}
      isProduct={true}
      isProductDetail={isProductDetail}
      setReloadSupplierList={handleReloadPage}
      isQaSpecPath={isQaSpecPath}
      isWorkflowModal={true}
      productId={productId}
    />
  );
};

export default QaSpecAssignToSupplierModal;
